export class FabricException extends Error {
  private type: string;
  constructor(message: string, errorType = '') {
    super(`${message}`);
    this.name = 'FabricException';
    this.type = errorType;
  }
  public get fabricExceptionType() {
    return this.type;
  }
}
export type FabricExceptionItem = Error | FabricException | null | undefined;
export type FabricMultiExceptionItems =
  | Array<Error | FabricException>
  | null
  | undefined;
